<template>
  <div class="detail">
    <div class="head">
      <div class="avatar">
        <van-image width="80" height="80" :src="qwUserInfo.external_contact.avatar" />
      </div>
      <div class="info">
        <span class="name">{{qwUserInfo.external_contact.name}}</span>
      <span class="wx-text" v-if="qwUserInfo.external_contact && qwUserInfo.external_contact.type == 1">@微信</span>
      <span class="wx-text" v-if="qwUserInfo.external_contact && qwUserInfo.external_contact.type == 2">@企微用户</span>
      </div>
     
    </div>
    
    <div class="baseInfo">
      <van-cell-group>
        <van-cell title="性别" v-if="qwUserInfo.external_contact && qwUserInfo.external_contact.gender == 1" value="男" />
        <van-cell title="性别" v-if="qwUserInfo.external_contact && qwUserInfo.external_contact.gender == 2" value="女" />
        <van-cell title="性别" v-if="qwUserInfo.external_contact && qwUserInfo.external_contact.gender == 0" value="未知" />
        <!-- <van-field v-model="note" label="备注" placeholder="" /> -->
        <van-cell title="备注" :value="userRemark" />
        <van-cell title="标签"  >
          <!-- <template slot="value">
            <div class="tag-list">
              <span v-for="(tag, tagIndex) in userTagList" :key="tagIndex" class="tag">{{ tag.tag_name }}</span>
            </div>
          </template> -->
        </van-cell>
        <div class="tag-list">
          <span v-for="(tag, tagIndex) in userTagList" :key="tagIndex" class="tag">{{ tag.tag_name }}</span>
        </div>
      </van-cell-group>
    </div>
    <div class="section" v-if="!sharUrl && studentList && studentList.length > 0">
      <div class="title">
        <h1 class="text">绑定信息</h1>
        <div class="link" @click="show = true">
          <van-icon name="exchange" color="#21b321" />
          <span class="text">切换绑定人</span>
        </div>
      </div>
      <div class="content">
         <div class="field">
            <div class="label">姓名</div>
            <div class="value">{{studentInfo.name}}</div>
         </div>
         <div class="field">
            <div class="label">性别</div>
            <div class="value" v-if="studentInfo.sex == 0">男</div>
            <div class="value" v-if="studentInfo.sex == 1">女</div>
            <div class="value" v-if="studentInfo.sex == 2">未知</div>
         </div>
         <div class="field">
            <div class="label">年龄</div>
            <div class="value">{{studentInfo.age}}</div>
         </div>
         <div class="field">
            <div class="label">出生日期</div>
            <div class="value">{{studentInfo.birthday}}</div>
         </div>
         <div class="field">
            <div class="label">医院</div>
            <div class="value">{{studentInfo.hospital_name}}</div>
         </div>
         <div class="field">
            <div class="label">学校/门诊</div>
            <div class="value">{{studentInfo.schoolName}}</div>
         </div>
         <div class="field">
            <div class="label">班级/科室</div>
            <div class="value">{{studentInfo.clazzName}}</div>
         </div>
         <div class="field">
            <div class="label">裸眼视力</div>
            <div class="value"><span>右眼：{{studentInfo.checkInfo? studentInfo.checkInfo.right_nakedeye_vision : '-'}}</span>   <span style="margin-left: 15px;">左眼：{{studentInfo.checkInfo? studentInfo.checkInfo.left_nakedeye_vision : '-'}}</span></div>
         </div>
          <div class="overflow-x-auto">
            <table class="w-full border-collapse fixed-table-layout">
              <tbody>
                <tr class="hover:bg-gray-50 transition-colors">
                  <td class="cell-padding border-b text-left font-semibold">屈光度</td>
                  <td class="cell-padding border-b font-semibold">球镜(S)</td>
                  <td class="cell-padding border-b font-semibold">柱镜(C)</td>
                  <td class="cell-padding border-b font-semibold">轴位(A)</td>
                  <td class="cell-padding border-b font-semibold">SE</td>
                </tr>
              </tbody>
              <tbody>
                <tr class="hover:bg-gray-50 transition-colors">
                  <td class="cell-padding border-b text-left">右眼</td>
                  <td class="cell-padding border-b">{{ studentInfo?.checkInfo?.avg_right_ball | formatFixed2 }}</td>
                  <td class="cell-padding border-b">{{ studentInfo?.checkInfo?.avg_right_syl | formatFixed2}}</td>
                  <td class="cell-padding border-b">{{ studentInfo?.checkInfo?.avg_right_axial | formatVal}}</td>
                  <td class="cell-padding border-b">{{ studentInfo?.checkInfo?.right_se | formatFixed2}}</td>
                </tr>
                <tr class="hover:bg-gray-50 transition-colors">
                  <td class="cell-padding border-b text-left">左眼</td>
                  <td class="cell-padding border-b">{{ studentInfo?.checkInfo?.avg_left_ball | formatFixed2 }}</td>
                  <td class="cell-padding border-b">{{ studentInfo?.checkInfo?.avg_left_syl | formatFixed2}}</td>
                  <td class="cell-padding border-b">{{ studentInfo?.checkInfo?.avg_left_axial | formatVal}}</td>
                  <td class="cell-padding border-b">{{ studentInfo?.checkInfo?.left_se | formatFixed2}}</td>
                </tr>
              </tbody>
            </table>
          </div>
         <div class="field">
            <div class="label">患者标签</div>
             <div class="value">
               <!--<van-tag class="student-tag" text-color="#2c3e50" :plain="true" size="small" round>糖尿病</van-tag>
               <van-tag class="student-tag" text-color="#2c3e50" :plain="true" size="small" round> 高血压</van-tag>-->
               <!-- 先校验 studentInfo 和 checkInfo 是否存在 -->
              <template v-if="studentInfo.checkInfo && studentInfo.checkInfo.taps">
                <van-tag
                  v-for="(tag, index) in studentInfo.checkInfo.taps"
                  :key="index"
                  class="student-tag"
                  text-color="#2c3e50"
                  :plain="true"
                  size="small"
                  round
                >
                  {{ tag }}
                </van-tag>
              </template>
              <!-- 可选：无标签时的提示 -->
              <template v-else>
                <span class="no-tag"></span>
              </template>
            </div>
         </div>
      </div>
    </div>
    <div class="section" v-if="!sharUrl && studentList && studentList.length > 0">
      <div class="title">
        <h1 class="text">检查信息</h1>
        <div class="link"  @click='openMini'>
          <van-icon name="list-switch" color="#21b321" />
          <span class="text">点击查看</span>
        </div>
      </div>
    </div>
    <div class="shareUrlDiv" v-if="sharUrl && sharUrl != 'undefined' && sharUrl != undefined">
      <span>客户暂未绑定，请复制地址发给用户点击</span>
      <van-button 
        type="primary"
        size="small"
        icon="down"
        v-clipboard:copy="sharUrl"
        v-clipboard:success="onCopySucess"
          v-clipboard:error="onCopyError"
        >复制链接</van-button>
    </div>
    <!-- <div v-if="!studentList || studentList.length < 1">
      <span>暂未绑定学生/患者</span>
    </div> -->
    <van-action-sheet v-model="show" title="选择绑定人">
      <div class="psn-select-content">
        <div class="psn-field" v-for="item in studentList" :key="item.studentId" @click="onSelect(item)">
          <div class="label">{{ item.name }}</div>
          <div class="value">{{ item.hospital_name }}</div>
        </div>
      </div>
    </van-action-sheet>
  </div>
</template>

<script>
import Vue from 'vue';
import { ActionSheet, Tag } from 'vant';
Vue.use(ActionSheet);
Vue.use(Tag);
export default {
  name: 'useridPage',
  data() {
    return {
      note: '', // 备注
      resultEntry: '',
      resultInterface: '',
      resultUserInfo: '',
      corpid: '',
      agentid: '',
      accountId: '',
      openId: '',
      code: '',
      qwUserInfo: {
        external_contact: {}
      },
      wxUserInfo: {},
      nowUser: {},
      sharUrl: '',
      studentInfo: {},
      studentList: [],
      userTagList: [], //tag_name
      userRemark: '',
      show: false
    };
  },
  mounted() {
    this.corpid = this.$route.query.corpid;
    this.accountId = this.$route.query.accountId;
    this.agentid = this.$route.query.agentid;
    this.openId = this.$route.query.openId;
    let urlAll = window.location.href;
    if (urlAll.indexOf('code=') >= 0) {
      let startIndex = urlAll.indexOf('?') + 1;
      let endIndex = urlAll.indexOf('#/');
      let params = urlAll.substring(startIndex, endIndex);
      let arr = params.split('&');
      for(var i = 0; i < arr.length; i++){
        
        if(arr[i].indexOf('=') >= 0){
          let varArr = arr[i].split('=');
          if (varArr[0] === 'code'){
            this.code = varArr[1]
          }
        }
      }
    }
    // this.code = this.$route.query.code;
    if (this.code) {
      //获取当前企业成员userid
      this.onGetQWUserInfo();
      // this.onGetUserid(0);
    }else {
      this.onGetUserid(1);
    }
    // this.getData(this.openId);
    
  },
  methods: {
    onGetHtml5() {
      try {
        wx.invoke('getContext', {
        }, (res) => {
          this.resultEntry = JSON.stringify(res);
          if (res.err_msg == "getContext:ok") {
            entry = res.entry; //返回进入H5页面的入口类型，目前有normal、contact_profile、single_chat_tools、group_chat_tools、chat_attachment
            shareTicket = res.shareTicket; //可用于调用getShareInfo接口
          } else {
            //错误处理
          }
        });
      } catch (e) {
        this.resultEntry = '调用getContext异常';
      }
    },
    onSelect(item) {
      // 默认情况下点击选项时不会自动收起
      // 可以通过 close-on-click-action 属性开启自动收起
      this.studentInfo = item
      this.show = false;
    },
    onCancel() {
      this.show = false;
    },
    handleErrorFn(e) {
      this.$toast({ message: '打开失败', duration: 1500 })
    },
    handleLaunchFn(e) {
      this.$toast({ message: '打开成功', duration: 1500 })
    },
    onCopySucess(e) {
      alert('复制链接成功');
    },
    onCopyError() {
      alert(`复制失败`);
    },
    openMini() {
      // this.studentInfo
      //${this.data.hospitalId}&archivesNo=&archivesDate=&studentId=&id=
      let path = 'pages/record/detail/index?hospId='+this.studentInfo.hospital_id+'&archivesNo='+this.studentInfo.archivesNo+
      '&isShare=1'+
      '&archivesDate='+this.studentInfo.archivesDate+'&studentId='+this.studentInfo.student_id+'&id='+this.studentInfo.archivesId
      +'&idCard='+this.studentInfo.id_card+'&studentType='+this.studentInfo.studentType+'&qcode='+encodeURIComponent(this.studentInfo.url);
      wx.invoke('launchMiniprogram', {
        	"appid" : "wx75e89ac1def51465", // 需跳转的小程序appid
          "path" : path, // 所需跳转的小程序内页面路径及参数。非必填
          }, function(res) {
            if(res.err_msg == "launchMiniprogram:ok") {
              // 正常
              // alert("正常打开")
            } else {
              // 错误处理
              alert("失败:"+JSON.stringify(res))
            }
          }
      );
    },
    async onGetUser() {
      try {
        wx.invoke('getCurExternalContact', {
        }, (res) => {
          if (res.err_msg == "getCurExternalContact:ok") {
            //userId  = res.userId ; //返回当前外部联系人userId
            this.resultUserInfo = res;
            if (this.openId && this.openId != undefined && this.openId != 'undefined'){
              this.getData(this.openId);
              //处理当前用户标签
              this.getQwUserTag();
            }else{
              this.onGetUserInfo();
            }
          } else {
            //错误处理
            // this.resultUserInfo = JSON.stringify(res);
            alert("getCurExternalContact异常:"+JSON.stringify(res))
          }
        });
      } catch (e) {
        alert('调用getCurExternalContact异常:'+e);
      }
    },
    async onGetQWUserInfo() {
      let result = await this.$http.get(this.$url.getQwUserId, {
        corpid: this.corpid,
        code: this.code,
      });
      this.nowUser = result.data.userInfo
      if (this.nowUser && this.nowUser.userid ){
        // this.onGetUserInfo(this.nowUser.userid);
        this.onGetUserid(0)
      }
    },
    async onGetUserInfo() {
      let result = await this.$http.get(this.$url.getQwUserOpenId, {
        corpid: this.corpid,
        userId: this.resultUserInfo.userId,
        qwUserId: this.nowUser ? this.nowUser.userid : ''
      });
      this.qwUserInfo = result.data.userInfo
      this.wxUserInfo = result.data.openIdInfo
      if (result.data.shareUrl){
        this.sharUrl = '请点击链接绑定您的专属咨询客服:\n'+result.data.shareUrl
      }
      if (this.wxUserInfo && this.wxUserInfo.openId){
        this.openId = this.wxUserInfo.openId
      }
      //处理当前用户标签
      this.getQwUserTag();
      if (this.openId) {
        this.getData(this.openId);
      }
    },
    async getQwUserTag(){
      let result = await this.$http.get(this.$url.getQwUserTag, {
        corpid: this.corpid,
        userId: this.resultUserInfo.userId
      });
      if (result &&  result.data.userInfo && result.data.userInfo.follow_user) {
        let followUserList = result.data.userInfo.follow_user
        for (let i = 0; i < followUserList.length; i++) {
          let userModel = followUserList[i];
          if (userModel.userid && userModel.userid == this.nowUser.userid){
            this.userTagList = userModel.tags;
          }
          this.userRemark = userModel.remark
        }
      }
    },
    async getData(openId) {
      let auth = this.$createAuth(this.$md5);
      let result = await this.$http.get(this.$url.getStudentsByOpenId2, {
        openId: openId,
        auth: auth.code,
        time: auth.time
      });
      if (result.message === 'Error: Miss auth parameter.'){
        alert('权限不足');
      }else {
        this.studentList = result.data.studentList;
        if (this.studentList && this.studentList.length > 0){
          this.studentInfo = this.studentList[0]
        }
      }
    },
    async onGetUserid(type) {
      let str = this.generateRandomString(16);
      let result = await this.$http.get(this.$url.getQwSign, {
        corpid: this.corpid,
        agentid: this.agentid,
        nonceStr: str,
        timestamp: Date.now(),
        pageUrl: window.location.href.split('#')[0]
      });
      let data = result.data.data;
      try {
        wx.agentConfig({
          corpid: data.corpid, // 必填，企业微信的corpid，必须与当前登录的企业一致
          agentid: data.agentid, // 必填，企业微信的应用id （e.g. 1000247）
          timestamp: data.timestamp, // 必填，生成签名的时间戳
          nonceStr: data.nonceStr, // 必填，生成签名的随机串
          signature: data.signature,// 必填，签名，见附录-JS-SDK使用权限签名算法
          jsApiList: ['getCurExternalContact', 'getContext', 'launchMiniprogram'], //必填，传入需要使用的接口名称
          success: (res) => {
            // 回调
            this.resultInterface = res;
            if (type && type === 1){
              let corpid = data.corpid;
              let originUrl = window.location.href;
              let redirectUrl = originUrl;
              let returnUrl = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${corpid}&redirect_uri=${encodeURIComponent(redirectUrl)}&response_type=code&scope=snsapi_base&state=STATE#wechat_redirect`
              window.location.href = returnUrl;
            }else {
              this.onGetUser();
            }
          },
          fail: (res) => {
            if (res.errMsg.indexOf('function not exist') > -1) {
              alert('版本过低请升级');
            }else {
              alert('调用agentConfig异常---'+JSON.stringify(res))
            }
          }
        });
      } catch (e) {
        alert('调用agentConfig异常:'+e);
      }
    },
    generateRandomString(length) {
      var chars = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789'; // 包含所有大写、小写字母和数字的字符集合
      var randomStr = '';

      for (var i = 0; i < length; i++) {
        var index = Math.floor(Math.random() * chars.length); // 根据长度从字符集合中选择一个索引值
        randomStr += chars[index]; // 将对应索引处的字符添加到结果字符串中
      }
      return randomStr;
    }
  },
  filters: {
    formatFixed2(value) {
      if (value == '0') value = '0.00'
      value = (value == null || value == 'null' || value == '')? '---' : (value > 0? '+' + parseFloat(value).toFixed(2) : parseFloat(value).toFixed(2));
      return value;
    },
    formatVal(value) {
      return value == null ? '---' : value;
    }
  }
}
</script>

<style scope lang="less">
.text-left {
  text-align: left;
}
.tag-list {
  display: flex;
  flex-wrap: wrap;
  .tag {
    padding: 6rpx 8rpx;
    margin-bottom: 6rpx;
    background: #F1F1F3FF;
    border-radius: 4px;
    margin: 5px;
  }
}
.button-box {
    display: flex;
    margin-top: 0.5rem;

    .button {
      width: 2.5rem;
      height: 0.8rem;
      line-height: 0.8rem;
      text-align: center;
      margin: 0 0.25rem;
      font-size: 0.3rem;
      border: 1px solid #ccc;
      border-radius: 0.2rem;
    }

    .button.ok {
      background: #59c8ac;
      color: #fff;
    }
  }
.van-cell {
  padding: 10px;
}
.green {
  color: #21b321;
}
  .detail {
    padding: 20px;
    text-align: left;
    .head {
      display: flex;
      align-items: center;
      padding-bottom: 10px;
      border-bottom: 1px solid #ccc;
      .avatar {
        width: 80px;
        height: 80px;
        border-radius: 10px;
        overflow: hidden;
      }
      .info {
        margin-left: 10px;

        .wx-text {
          color: #21b321;
        }
      }
    }
    .baseinfo {

    }
    .section {
      .title {
        display: flex;
        justify-content: space-between;
        align-items: center;

        .text {
          font-size: 0.29rem;
          color: #000;
        }
        .link {
          color: #21b321;
          display: flex;
          align-items: center;

          .text {
            margin-left: 6px;
          }
        }
      }
      .content {
        // padding: 6px;
        .field {
          padding: 0.18rem;
          display: flex;
          font-size: 0.28rem;
          // align-items: center;

          .label {
            width: 1.5rem;
            margin-right: 0.1rem;
            
          }
          .value {
            flex: 1;
            overflow: hidden;
          }

        }
      }
    }

    .psn-select-content {
      // padding: 10px;

      .psn-field {
        padding: 10px 20px;
        display: flex;
        justify-content: space-between;
        border-bottom: 1px solid #f6f6f6;
        .value {
          color: #8491a5;
        }
      }
    }
  }
.student-tag {
  margin-right: 5px;
    padding: 4px 6px;
}
.cell-padding {
  // padding: 0.75rem 1rem;
  width: 20%;

}
.fixed-table-layout {
  width: 100%;
  text-align: center;
  margin-left: 2%;
}
</style>
